type Model = string[]
type Module = Record<string, Model>
type Service = Record<string, Module>
export type Permissions = Record<string, Service>
export type perm = Record<string, string>
export type ClientConfigPermissions = {
  whiteLabelPermission: boolean
  siteConfigurationPermission: boolean
  productConfigurationPermission: boolean
}
export type ClientReportingPermissions = {
  reportingSettings: boolean
  groups: boolean
  users: boolean
}

export const getPermissionMap = (permissionScopes: string[]) => {
  const permissionMap = {} as Permissions
  permissionScopes.forEach((perm_scope) => {
    let permissionScopeSplit = perm_scope.split('/')
    const service = permissionScopeSplit[0]
    permissionScopeSplit = permissionScopeSplit[1].split(':')
    const module = permissionScopeSplit[0]
    permissionScopeSplit = permissionScopeSplit[1].split('.')
    const model = permissionScopeSplit[0]
    const PermissionProvided = permissionScopeSplit[1]
    permissionMap[service] = permissionMap[service] || {}
    permissionMap[service][module] = permissionMap[service][module] || {}
    permissionMap[service][module][model] = permissionMap[service][module][model] || []
    permissionMap[service][module][model].push(PermissionProvided)
  })
  return permissionMap
}

export const hasPermission = (
  servicePermissionMap: Service,
  module: string,
  model: string,
  permissionToCheck: string[],
) => {
  let hasPerm = false
  if (servicePermissionMap?.[module]?.[model]) {
    permissionToCheck.forEach((perm) => {
      hasPerm = servicePermissionMap[module]?.[model].includes(perm) || hasPerm
    })
    return hasPerm
  }
  if (servicePermissionMap?.[module]?.['*']) {
    permissionToCheck.forEach((perm) => {
      hasPerm = servicePermissionMap[module]?.['*'].includes(perm) || hasPerm
    })
    return hasPerm
  }
  if (servicePermissionMap?.['*']?.['*']) {
    permissionToCheck.forEach((perm) => {
      hasPerm = servicePermissionMap['*']?.['*'].includes(perm) || hasPerm
    })
  }
  return hasPerm
}

export const hasAnyPermission = (servicePermissionMap: Service, module: string, model: string): boolean => {
  if (
    servicePermissionMap['*']?.['*'] ||
    servicePermissionMap[module]?.[model] ||
    servicePermissionMap[module]?.['*']
  ) {
    return true
  }
  return false
}

export const getCCSPermissions = (permissions: string[]): ClientConfigPermissions => {
  let whiteLabelPermission = false
  let siteConfigurationPermission = false
  let productConfigurationPermission = false
  if (permissions) {
    const permissionMap = getPermissionMap(permissions)
    if (permissionMap?.['client-configuration-service']) {
      const ccsPermissionMap = permissionMap['client-configuration-service']
      whiteLabelPermission = hasAnyPermission(ccsPermissionMap, 'white_label_configuration', '*')
      siteConfigurationPermission = hasAnyPermission(ccsPermissionMap, 'site_configuration', '*')
      productConfigurationPermission = hasAnyPermission(ccsPermissionMap, 'product_configuration', '*')
    }
  }
  return { whiteLabelPermission, siteConfigurationPermission, productConfigurationPermission }
}

export const getCRSPermissions = (permissions: string[]): ClientReportingPermissions => {
  let reportingSettings = false
  let groups = false
  let users = false
  if (permissions) {
    const permissionMap = getPermissionMap(permissions)
    if (permissionMap?.['client-reporting-service']) {
      const crsPermissionMap = permissionMap['client-reporting-service']
      reportingSettings = hasAnyPermission(crsPermissionMap, 'reporting_settings', '*')
      groups = hasAnyPermission(crsPermissionMap, 'groups', '*')
      users = hasAnyPermission(crsPermissionMap, 'users', '*')
    }
  }
  return { reportingSettings, groups, users }
}

export const hasAnyCRSPermission = (permissions: ClientReportingPermissions): boolean => {
  return permissions.groups || permissions.reportingSettings || permissions.users
}
